// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IAsyncUsageInfo {
	statusTimestamp: string | undefined;

	pendingTasks: number;

	totalThreads: number;

	availableIO: number;

	availableWorker: number;

	ioInUse: number;

	workersInUse: number;

	$type?: string | undefined;
}
export class AsyncUsageInfo {
	constructor(data?: IAsyncUsageInfo) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.statusTimestamp) { this.statusTimestamp = new Date(data.statusTimestamp); }
	}

	statusTimestamp: Date | undefined = new Date();

	pendingTasks: number = 0;

	totalThreads: number = 0;

	availableIO: number = 0;

	availableWorker: number = 0;

	ioInUse: number = 0;

	workersInUse: number = 0;

	static $type: string = "Shared.Models.View.Hardware.AsyncUsageInfo, ";
	$type?: string | undefined = AsyncUsageInfo.$type;
}

